import {computed, onMounted, ref} from "vue";

export const useResponsive = () => {
  onMounted(() => {
    screenWidth.value = window.innerWidth;
    window.addEventListener('resize', () => {
      screenWidth.value = window.innerWidth;
    });
  });

  // `screen.width` is the physical display resolution, not the actual viewport — wrong
  // signal for responsive layout (mismatches in emulated/resized/split-screen viewports).
  const screenWidth = ref(typeof window !== 'undefined' ? window.innerWidth : 1024);

  const isMobile = computed(() => {
    return screenWidth.value <= 500;
  });

  return {
    isMobile
  }
}
